module.exports = __webpack_public_path__ + "img/proyecto_11_mv.6131661b.webp";